import { createBreakpoint } from "react-use";

const breakpoints = { sm: 640, md: 768, lg: 1024, xl: 1280, "2xl": 1536 };

export default function useBreakpoints() {
  const breakpoint = createBreakpoint(breakpoints)();
  const isMobile = ["sm", "md"].includes(breakpoint);
  return [isMobile, breakpoint];
}
